import { Component, Input, OnInit } from '@angular/core';
import { ShowOrHideComponent } from '../../models/showOrHideComponent';
import { ShowOrHideSpinner } from '../../models/showOrHideSpinner';
import { SpinnerService } from '../../services/spinner.service';
import { AnalysisMessages } from '../../models/component-messages/analysis-messages';

@Component({
  selector: 'app-analyse',
  templateUrl: './analyse.component.html',
  styleUrls: ['./analyse.component.scss']
})
export class AnalyseComponent extends ShowOrHideSpinner implements OnInit, ShowOrHideComponent {

  @Input() title: string;
  @Input() message: string;
  public analysisMessages = new AnalysisMessages();

  constructor(private spinnerService: SpinnerService) {
    super();
  }

  showComponent() {
    return !this.isSpinnerNotInProgress(this.spinnerService);
  }

  ngOnInit() {
  }
}
